import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState('tenant', [
      'tenants',
    ]),
    contractFilterItems() {
      const contractsSelected = this.tenants.map(tenant => ({ text: tenant.data.name, value: tenant.id, tenant }));
      return contractsSelected;
    },
    botFilterItems() {
      if (!Boolean(this.tempFilter.contracts?.value)) {
        return this.tenants
          .map(({ data }) => data.applications.map(bot => ({ ...bot, id: data.id })))
          .flat()
          .map(({ name, accessKey, id }) => ({
            text: name,
            value: accessKey,
            contract: id,
          }));
      }

      return this.tenants
        .filter(({ id }) => this.tempFilter.contracts.value.includes(id))
        .map(({ data }) => data.applications.map(bot => ({ ...bot, id: data.id })))
        .flat()
        .map(({ name, accessKey, id }) => ({
          text: name,
          value: accessKey,
          contract: id,
        }));
    },
    allBotFilterItems() {
      return this.tenants
        .map(({ data }) => data.applications.map(bot => ({ ...bot, id: data.id })))
        .flat()
        .map(({ name, accessKey, id }) => ({
          text: name,
          value: accessKey,
          contract: id,
        }));
    },
  },
};
